// @flow
export { default } from './UserHead';



// WEBPACK FOOTER //
// ./src/components/user/UserHead/index.js